import EditarQuinielaPrivada from './EditarQuinielaPrivada';
export default EditarQuinielaPrivada;
